<template>
    <div class="profile-card-horizontal">
        <div class="image">
            <logo-icon :active="true" width="80" />
            <img width="120">
        </div>
        <div class="text">
            <h4>{{ name }}</h4>
            <p>{{ description }}</p>
            <router-link class="link" :to="to">VER PERFIL
                <arrow-horizontal width="15" />
            </router-link>
        </div>
    </div>
</template>

<script>
import LogoIcon from "./Svg/LogoIcon";
import ArrowHorizontal from "@/components/Svg/ArrowHorizontal";
export default {

    components: { LogoIcon, ArrowHorizontal },

    props: ['name', 'description', 'to']

}
</script>
